import { removeEmptyValues } from '@partoohub/utils';

import { useGetBusinessModalFiltersState } from './useGetBusinessModalFiltersState';
import { BusinessModalQueryParams, queryParamToRequestParamMap } from '../helpers/queryParams';

type FilterKey = ReturnType<typeof useGetBusinessModalFiltersState>;

export const useBusinessModalFilterByKey = (
    keys: BusinessModalQueryParams[] = [],
): Partial<Record<string, string | undefined>> => {
    const state = useGetBusinessModalFiltersState();

    const result = keys.reduce(
        (result, key) => {
            const mappedKey = queryParamToRequestParamMap[key];
            if (mappedKey && mappedKey in state) {
                result[mappedKey] = state[mappedKey as keyof FilterKey][0];
            }
            return result;
        },
        {} as Partial<Record<string, string | undefined>>,
    );

    return removeEmptyValues(result);
};
